import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const useGetTrialStatus = () => {
  const { getTrialStatus } = useServicesContext();

  return useQuery({
    queryKey: ['GET_TRIAL_STATUS'],
    queryFn: getTrialStatus,
    staleTime: Infinity,
  });
};
